import React from 'react';
import { Tooltip } from '@andes/tooltip';
import { tooltipHoverPropTypes } from '../../model';
import { MediaAction } from '@vpp-frontend-components/media';
import { StyledLabel } from '@vpp-frontend-components/styled-label';

export const TooltipHover = ({ className = '', children, hoverInfo = null, isVisible, onOpen }) => (
  <Tooltip
    className={className}
    content={<StyledLabel {...hoverInfo.body} />}
    actions={<MediaAction {...hoverInfo.action} />}
    open={isVisible}
    autoHideDelay={0}
    onOpen={onOpen}
  >
    {children}
  </Tooltip>
);

TooltipHover.propTypes = tooltipHoverPropTypes;
